import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isIntersecting"];
import I18n from 'I18n';
import { OBSIDIAN, OLAF } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import UIIntersectionObserver from 'UIComponents/observer/UIIntersectionObserver';
import { useRef } from 'react';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIButton from 'UIComponents/button/UIButton';
import ResponsiveRenderer from 'developer-docs-shared-components/components/ResponsiveRenderer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The length of each side on the arrow link square.
 */
const LINK_SIDE_LENGTH = '47px';

/**
 * The invisible target which spans the lower portion of the scrollable
 * container. Used to conditionally render the arrow when the target is in the
 * viewport.
 */
const Target = styled.div.withConfig({
  displayName: "MobileScrollToTop__Target",
  componentId: "sc-1vq1x7l-0"
})(["visibility:hidden;position:absolute;bottom:0;right:40px;height:40%;pointer-events:none;"]);

/**
 * The icon within the 'scroll to top' link.
 */
const ArrowIcon = styled(UIIcon).withConfig({
  displayName: "MobileScrollToTop__ArrowIcon",
  componentId: "sc-1vq1x7l-1"
})(["line-height:", ";"], LINK_SIDE_LENGTH);

/**
 * A button containing an arrow with localized screen reader text.
 */
const ArrowButton = styled(_ref => {
  let rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UIButton, Object.assign({}, rest, {
    use: "unstyled",
    children: /*#__PURE__*/_jsx(ArrowIcon, {
      name: "up",
      color: OLAF,
      screenReaderText: I18n.text('developer-docs-ui.accessibility.scrollToTop'),
      size: 24
    })
  }));
}).withConfig({
  displayName: "MobileScrollToTop__ArrowButton",
  componentId: "sc-1vq1x7l-2"
})(["&&{width:", ";height:", ";text-align:center;border:2px solid ", ";background-color:", ";position:fixed;z-index:1;right:3px;bottom:10%;box-shadow:0 3px 15px rgba(0,0,0,0.2);opacity:", ";transform:", ";transition:transform 0.5s ease,opacity 0.5s ease;}"], LINK_SIDE_LENGTH, LINK_SIDE_LENGTH, OLAF, OBSIDIAN, ({
  isIntersecting
}) => isIntersecting ? 1 : 0, ({
  isIntersecting
}) => isIntersecting ? 'translateY(0)' : `translateY(25vh)`);

/**
 * A scroll to top link that appears on mobile 60% of the way down the page.
 * Must be placed within a relatively-positioned container.
 */
const MobileScrollToTop = ({
  href,
  initialIntersecting = false
}) => {
  const targetRef = useRef(null);
  return /*#__PURE__*/_jsx(ResponsiveRenderer, {
    renderMobile: () => /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Target, {
        ref: targetRef,
        "data-test-id": "MobileScrollToTop-target"
      }), /*#__PURE__*/_jsx(UIIntersectionObserver, {
        initialIntersecting: initialIntersecting,
        renderContent: isIntersecting => /*#__PURE__*/_jsx(ArrowButton, {
          "data-intersecting": isIntersecting,
          isIntersecting: isIntersecting,
          href: href
        })
        // @ts-expect-error incorrect type upstream
        ,
        target: targetRef.current
      })]
    }),
    renderDesktop: () => null
  });
};
export default MobileScrollToTop;